import { logoutUser } from "@/services/user";

export const logout = (mutateUser: any) => async () => {
  logoutUser().then(async () => {
    mutateUser();
  });
};
